import React, { useEffect, useReducer } from 'react';
import { StateType, ActionType, globalReducer } from 'client/contexts/global/reducer';

type ContextType = {
  globalState: StateType;
  globalDispatch: React.Dispatch<ActionType>;
};

type Props = {
  token: string | undefined;
};

export const initialState = { token: undefined };
export const GlobalContext = React.createContext({} as ContextType);

export const GlobalContextProvider: React.FC<Props> = ({ children, token }) => {
  const [globalState, globalDispatch] = useReducer(globalReducer, initialState);

  useEffect(() => {
    if (typeof token === 'string' && !globalState.token) {
      globalDispatch({
        type: 'setToken',
        token,
      });
    }
  }, []);

  return <GlobalContext.Provider value={{ globalState, globalDispatch }}>{children}</GlobalContext.Provider>;
};
